import { render, staticRenderFns } from "./SimpleList.vue?vue&type=template&id=3ccbcdb5&"
import script from "./SimpleList.vue?vue&type=script&lang=js&"
export * from "./SimpleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports